import React from "react";
import "./Testimonials.css";
import Avatar1 from "../../assests/Avatar1.jpg";
import Avatar2 from "../../assests/Avatar2.jpg";
import Avatar3 from "../../assests/Avatar3.jpg";
import Avatar4 from "../../assests/Avatar4.jpg";
import Avatar5 from "../../assests/Avatar5.jpg";
import { Pagination } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

const data = [
  {
    avatar: Avatar1,
    name: "Rushabh Vin",
    review:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam sint maiores expedita, assumenda voluptatibus officia reprehenderit, dignissimos pariatur excepturi quasi neque! Aliquid pariatur, modi hic neque ipsam asperiores soluta nostrum sequi necessitatibus animi consectetur nulla.",
  },
  {
    avatar: Avatar2,
    name: "Jeel Madaliya",
    review:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam sint maiores expedita, assumenda voluptatibus officia reprehenderit, dignissimos pariatur excepturi quasi neque! Aliquid pariatur, modi hic neque ipsam asperiores soluta nostrum sequi necessitatibus animi consectetur nulla.",
  },
  {
    avatar: Avatar3,
    name: "Vaishnavi Rathod",
    review:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam sint maiores expedita, assumenda voluptatibus officia reprehenderit, dignissimos pariatur excepturi quasi neque! Aliquid pariatur, modi hic neque ipsam asperiores soluta nostrum sequi necessitatibus animi consectetur nulla.",
  },
  {
    avatar: Avatar4,
    name: "Honey Patel",
    review:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam sint maiores expedita, assumenda voluptatibus officia reprehenderit, dignissimos pariatur excepturi quasi neque! Aliquid pariatur, modi hic neque ipsam asperiores soluta nostrum sequi necessitatibus animi consectetur nulla.",
  },
  {
    avatar: Avatar5,
    name: "Sonali Gorajiya",
    review:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam sint maiores expedita, assumenda voluptatibus officia reprehenderit, dignissimos pariatur excepturi quasi neque! Aliquid pariatur, modi hic neque ipsam asperiores soluta nostrum sequi necessitatibus animi consectetur nulla.",
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials">
      <h5>Review from the clients</h5>
      <h2>Testimonials</h2>
      <Swiper
        className="container testimonials__container"
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {data.map(({ avatar, name, review }, index) => {
          return (
            <SwiperSlide key={index} className="testimonial">
              <div className="client__avatar">
                <img src={avatar} alt="" />
              </div>
              <h5 className="client__name">{name}</h5>
              <small className="client__review">{review}</small>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Testimonials;
